import { createContext, useContext } from "react";

// Direction of the current route transition: "forward" | "back" | "none"
export const DirContext = createContext("none");
export const useDir = () => useContext(DirContext);

// Navigation depth drives push/pop slide direction.
export function depthOf(pathname) {
  if (pathname.startsWith("/jobs/") && pathname.includes("/reports/")) return 3;
  if (pathname.startsWith("/jobs/")) return 2;
  return 1;
}

// Logical parent of an in-app screen — powers native-feeling "up" navigation
// (hardware back goes up the Jobs → Job → Report tree, not through raw history).
// Returns null for marketing/auth/public routes, where normal web back applies.
export function parentOf(pathname) {
  if (pathname.startsWith("/jobs/") && pathname.includes("/reports/")) {
    return pathname.split("/reports/")[0]; // report → its job
  }
  if (pathname.startsWith("/jobs/")) return "/dashboard"; // job → jobs list
  if (["/activity", "/account", "/testers"].includes(pathname)) return "/dashboard";
  return null;
}

// The app "home" — hardware back here prompts to exit instead of unwinding.
export const isAppRoot = (p) => p === "/dashboard";

// In-app "up" navigation that keeps browser history clean. If we arrived here
// from within the app, pop the stack (navigate(-1)) so the device/hardware back
// button walks the Jobs → Job → Report hierarchy naturally instead of replaying
// a polluted history. On a deep link (first entry) fall back to the parent path.
export function goBackOrParent(navigate, parentPath) {
  const st = window.history.state;
  const idx = st && typeof st.idx === "number" ? st.idx : 0;
  if (idx > 0) navigate(-1);
  else navigate(parentPath, { replace: true });
}
